import { RouterProvider } from '@tanstack/react-router';

import { router } from '@/index';

export function App() {
  return <RouterProvider router={router} />;
}
